/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import ConfirmationWithBackButton from 'src/components/Compliance/ConfirmationWithBackButton';
import MessageBox from 'src/components/Compliance/MessageBox';
import { UpdateApplication } from 'src/redux/actions/Application';
import BadgeImg from '../../assets/images/FramedImage.png';
import Logomark from '../../assets/images/Logomark.png';

const AlreadyCoveragePurchased = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    localStorage.clear();
    dispatch(UpdateApplication({}));
  },[]);

  return (
    <ConfirmationWithBackButton
      title="You have already purchased a policy."
      subtitle="Check your inbox for a confirmation email."
      image={BadgeImg}
      goBackLink="/learn"
      message=<MessageBox
        image={Logomark}
        title="Still have question?"
      />
    />
  );
};

export default AlreadyCoveragePurchased;
